import pageHeader from './header/pageHeader.vue';
import detailsHeader from './header/detailsHeader.vue';
import backButton from './header/backButton.vue';

export default {
    pageHeader,
    detailsHeader,
    backButton
}